module.exports = __webpack_public_path__ + "img/icon-arrow-right-warning.bcf4cf6b.svg";